import styled from 'styled-components';

export const Section = styled.section`
  padding-inline: 12px;

  @media ${({ theme }) => theme.media.tablet} {
    padding-inline: 24px;
  }
`;
